import { trackProductEvent } from '../product-analytics';

export type VoiceRole = 'seeker' | 'employer';

export interface VoiceEventBaseProps {
  role?: VoiceRole;
  language?: 'en' | 'ar' | 'mixed';
  surface?: 'composer' | 'handsfree' | 'voice-test';
  [key: string]: unknown;
}

export function trackVoiceSessionStarted(props: VoiceEventBaseProps): void {
  trackProductEvent('voice_session_started', props);
}

export function trackVoiceTranscribeSuccess(
  props: VoiceEventBaseProps & { durationMs: number; confidence?: number },
): void {
  trackProductEvent('voice_transcribe_success', props);
}

export function trackVoiceTranscribeFailed(
  props: VoiceEventBaseProps & {
    errorKind: 'auth' | 'rate_limit' | 'bad_request' | 'unavailable' | 'timeout' | 'network' | 'unknown';
  },
): void {
  trackProductEvent('voice_transcribe_failed', props);
}

export function trackVoiceSynthesizeSuccess(
  props: VoiceEventBaseProps & { durationMs: number; textLength: number },
): void {
  trackProductEvent('voice_synthesize_success', props);
}

export function trackVoiceSynthesizeFailed(
  props: VoiceEventBaseProps & { errorKind: string },
): void {
  trackProductEvent('voice_synthesize_failed', props);
}

export function trackVoiceCapReached(
  props: VoiceEventBaseProps & { usedMs: number; capMs: number },
): void {
  trackProductEvent('voice_cap_reached', props);
}

export function trackVoiceHandsfreeEntered(props: VoiceEventBaseProps): void {
  trackProductEvent('voice_handsfree_entered', props);
}

export function trackVoiceHandsfreeExited(
  props: VoiceEventBaseProps & { reason: 'user' | 'background' | 'error'; durationMs: number },
): void {
  trackProductEvent('voice_handsfree_exited', props);
}

export function trackVoiceInterrupt(props: VoiceEventBaseProps): void {
  trackProductEvent('voice_interrupt', props);
}

export function trackVoiceOfflineFallback(props: VoiceEventBaseProps): void {
  trackProductEvent('voice_offline_fallback', props);
}

export function trackVoicePermDenied(props: VoiceEventBaseProps): void {
  trackProductEvent('voice_perm_denied', props);
}
